import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Mixin from './mixin';
export default {
  name: buildComponentName('ListItemMeta'),
  isListItemMeta: true,
  mixins: [Mixin],
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  computed: {
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-item-meta");
    },
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    }
  },
  methods: {
    renderChildren: function renderChildren() {
      var h = this.$createElement;
      var _this$$slots = this.$slots,
          slotAvatar = _this$$slots.avatar,
          slotTitle = _this$$slots.title,
          slotDesc = _this$$slots.desc,
          prefixCls = this.prefixCls,
          title = this.title,
          desc = this.desc;
      var titleContent = slotTitle || title;
      var descContent = slotDesc || desc;
      var avatarElement = slotAvatar ? h("div", {
        "class": "".concat(prefixCls, "-avatar")
      }, [slotAvatar]) : null;
      var content = titleContent || descContent ? h("div", {
        "class": "".concat(prefixCls, "-content")
      }, [titleContent ? h("h4", {
        "class": "".concat(prefixCls, "-title")
      }, [titleContent]) : null, descContent ? h("div", {
        "class": "".concat(prefixCls, "-description")
      }, [descContent]) : null]) : null;
      return [avatarElement, content];
    }
  },
  render: function render() {
    var h = arguments[0];
    var $attrs = this.$attrs,
        classes = this.classes,
        renderChildren = this.renderChildren;
    return h("div", _mergeJSXProps([{}, {
      class: classes,
      attrs: $attrs
    }]), [renderChildren()]);
  }
};